import { SelectOption } from "@pulseops/common"

export namespace ACMetricHistoryDetailForm {
  export interface ACSearchedMetricHistoryDetail{
    from: Date | null
    to: Date | null
    groupMetric: SelectOption | undefined
    creator: string,
    status:  SelectOption | undefined
  }
} 